import React from "react";
import { contrasts, pillars } from "../data/landing";
export function MethodSection() {
  return <section id="metodo" className="scroll-mt-20 border-b border-line" data-id="element-124" data-mp="7t23p02gxfzu">
      <div className="mx-auto max-w-6xl px-6 py-20 md:py-28" data-id="element-125" data-mp="2u8q77n6lozo">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-20" data-id="element-126" data-mp="2uqqqggvmpde">
          <div data-id="element-127" data-mp="3uyt3phjsaszr">
            <h2 className="font-serif text-4xl leading-tight text-cream md:text-5xl" data-id="element-128" data-mp="3uzckguxp7bc7">
              No falta deseo.
              <span className="block text-gold" data-id="element-129" data-mp="vi4j019mqwr6">Falta reprogramación interna.</span>
            </h2>
            <p className="mt-6 text-base leading-relaxed text-muted" data-id="element-130" data-mp="qkl5j3krao0a">
              Precios que cambian, noticias que alteran el ánimo, conversaciones cargadas de miedo.
              No es lo mismo hablar de abundancia desde un país estable que hacerlo mientras el
              dólar sube y la mente está en alerta permanente. La mayoría intenta mejorar su
              realidad desde una mente agotada.
            </p>
          </div>

          <ul className="divide-y divide-line border-y border-line" data-id="element-131" data-mp="1v2ils4lgj9t4">
            {contrasts.map(item => <li key={item.wish} className="py-5" data-id="element-132" data-mp="201v88o8f2ev6">
                <p className="text-cream" data-id="element-133" data-mp="200k2iiveux1f">{item.wish}</p>
                <p className="mt-1 text-muted" data-id="element-134" data-mp="1ld7e8me7yd7c">{item.reality}</p>
              </li>)}
          </ul>
        </div>

        <div className="mt-20 grid gap-10 rounded-2xl bg-surface p-8 md:p-12 lg:grid-cols-[1fr_1.2fr] lg:gap-16" data-id="element-135" data-mp="1q9xupatxrata">
          <div data-id="element-136" data-mp="1cag1mj9lxbe4">
            <h3 className="font-serif text-3xl leading-snug text-cream" data-id="element-137" data-mp="1ce3udg789trs">
              La crisis puede seguir afuera, pero no tiene por qué gobernar tu mundo interno.
            </h3>
            <p className="mt-5 leading-relaxed text-muted" data-id="element-138" data-mp="12fo41fg0yojc">
              Mindset Anti-Fragilidad no te pide que ignores lo que pasa afuera. Te enseña a dejar
              de entregarle tu mente al miedo colectivo, y a transformar tu relación con la crisis,
              el dinero, la incertidumbre y tu propio merecimiento.
            </p>
          </div>
          <div data-id="element-139" data-mp="309s5mkt23h1h">
            <p className="text-sm font-medium text-gold" data-id="element-140" data-mp="30abelc0qav3d">Combina principios de</p>
            <ul className="mt-5 flex flex-wrap gap-2.5" data-id="element-141" data-mp="2v9dyd4za4b4i">
              {pillars.map(pillar => <li key={pillar} className="rounded-full border border-line px-4 py-2 text-sm text-cream" data-id="element-142" data-mp="2qcdsov6cdadx">
                  {pillar}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}